// extracted by mini-css-extract-plugin
module.exports = {"callAction":"CallToActionButton_callAction__10tj2"};